import { AlertCircle, Sparkles, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface QuotaBannerProps {
  used: number;
  limit: number;
  remaining: number;
  isUnlimited?: boolean;
  onUpgrade?: () => void;
  variant?: "compact" | "full";
}

export function QuotaBanner({ used, limit, remaining, isUnlimited, onUpgrade, variant = "compact" }: QuotaBannerProps) {
  if (isUnlimited) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-primary">
        <Sparkles className="h-3 w-3" />
        <span className="font-medium">Uso ilimitado</span>
      </div>
    );
  }

  const isLow = remaining > 0 && remaining <= 3;
  const isOut = remaining <= 0;

  if (variant === "compact") {
    return (
      <div
        className={cn(
          "flex items-center gap-1.5 text-xs font-medium",
          isOut ? "text-destructive" : isLow ? "text-yellow-600" : "text-muted-foreground"
        )}
      >
        <Zap className="h-3 w-3" />
        <span>
          {used}/{limit} mensagens hoje
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "rounded-lg border p-3 flex items-start gap-3",
        isOut
          ? "border-destructive/30 bg-destructive/5"
          : isLow
            ? "border-yellow-500/30 bg-yellow-500/5"
            : "border-border bg-muted/30"
      )}
    >
      <AlertCircle
        className={cn(
          "h-4 w-4 mt-0.5 shrink-0",
          isOut ? "text-destructive" : isLow ? "text-yellow-600" : "text-muted-foreground"
        )}
      />
      <div className="flex-1 text-sm">
        <p className="font-semibold">
          {isOut
            ? "Cota diária esgotada"
            : isLow
              ? `Apenas ${remaining} ${remaining === 1 ? "mensagem restante" : "mensagens restantes"} hoje`
              : `${used}/${limit} mensagens usadas hoje`}
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          {isOut
            ? "A cota é renovada à meia-noite. Faça upgrade para continuar agora."
            : "Cota renovada diariamente à meia-noite."}
        </p>
        {isOut && onUpgrade && (
          <Button size="sm" className="mt-2 h-7 text-xs gap-1" onClick={onUpgrade}>
            <Sparkles className="h-3 w-3" /> Fazer upgrade PRO
          </Button>
        )}
      </div>
    </div>
  );
}
